import { makeStyle } from '../../../../utils';
import { blackHigh, blackOutline, blackMedium, overline, subTitle2, subTitle1, black } from '../../../../resources/styles';
import view from '../../../../Enums';

const styles = {};

styles['container'] = makeStyle({
    height: 56,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${blackOutline.color}`,
});

styles['left'] = makeStyle({
    display: 'flex',
    alignItems: 'center',
});

styles['menu'] = makeStyle({ margin: 4 });

styles['menu_icon'] = makeStyle({ ...blackHigh });

styles['oyo'] = makeStyle(null, null, { display: 'none' }, { display: 'none' });

styles['left_divider'] = makeStyle({
    backgroundColor: blackOutline.color,
    width: 1, height: 16,
    margin: '0 12px',
    display: 'none',
}, { display: 'block' });

styles['owner_portal'] = makeStyle({
    ...overline,
    letterSpacing: '0.4px',
    ...blackMedium,
    display: 'none',
}, { display: 'block' });

styles['page_title'] = makeStyle({
    ...subTitle1,
    fontWeight: 'bold',
    ...black,
}, { display: 'none' });

styles['right'] = makeStyle({
    display: 'flex',
    alignItems: 'center',
});

styles['need_help'] = makeStyle({
    ...subTitle2,
    ...blackHigh,
    cursor: 'pointer',
    display: 'none',
}, { display: 'block',marginRight: 24 },{marginRight: 18},view.TAB);

styles['earning'] = makeStyle({
    ...subTitle2,
    ...blackHigh,
    cursor: 'pointer',
    display: 'none',
}, { display: 'block',marginRight: 24 },{marginRight: 18},view.TAB);

styles['right_divider'] = makeStyle({
    backgroundColor: blackOutline.color,
    width: 1,
    alignSelf: 'stretch',
    display: 'none',
}, { display: 'block' });

export default styles;